module.exports = __webpack_public_path__ + "img/fujianTitle.bd935e25.png";